import 'rxjs/add/operator/do';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Mensagens } from 'app/shared/utils/mensagens';
import { Observable, ReplaySubject } from 'rxjs/Rx';
import { NotificationService } from './shared/utils/notification.service';
import { AppInsightsService } from '@markpieszak/ng-application-insights';

declare var $: any;

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  static dataStream: ReplaySubject<any> = new ReplaySubject();

  static notificarObservers() {
    ResponseInterceptor.dataStream.next(true);
  }

  constructor(private notificationService: NotificationService,
    private appInsightsService: AppInsightsService) {
  }

  dataStream$(): Observable<any> {
    return ResponseInterceptor.dataStream.asObservable();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    return next.handle(req)
      .do((event: HttpEvent<any>) => { })
      .map(resp => {
        return resp;
      }).catch(err => {
        return Observable.throw(err);
      });
  }

  exibirJanelaRenovacaoAutenticacao(error) {
    if (error.status === 401 || error.status === 403) {
      ResponseInterceptor.notificarObservers();
    } else {
      if (error.error.errors) {
        this.notificationService.exibirNotificacaoErro('Erro', error.error.errors.join('<br/>'));
        return Observable.throw(error);
      } else {
        const errMsg = (error.message) ? error.message :
          error.status ? `${error.status} - ${error.statusText}` : Mensagens.OcorreuErroInesperado;
        console.error(error, errMsg);
        const retorno = new Array(1);
        retorno.push(errMsg);
        return Observable.throw(retorno);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/request-interceptor.ts